import React from "react";
import { FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import "./Footer.css";
import emailjs from "emailjs-com";
const Footer = () => {
  function sendEmail(e) {
    e.preventDefault();

    const name = document.getElementById("name").value;
    // console.log(e.target);
    emailjs
      .sendForm(
        "gmail",
        "template_d64h6op",
        e.target,
        "user_paTmxt1GHxfZ5ocVRURRk"
      )
      .then(
        (result) => {
          alert(`Thanks ${name}, I will shortly connect with you!`);
          // e.target.value = " ";
          document.getElementById("email").value = "";
          document.getElementById("subject").value = "";
          document.getElementById("textarea").value = "";
          document.getElementById("name").value = "";
        },
        (error) => {}
      );
  }

  return (
    <div id='footer-id' className='footer pt-5'>
      <div className='container'>
        <div>
          <div className='row  my-5'>
            <div className='col-md-6'>
              <h3 className='text-center mb-4'>Get in Touch</h3>
              <form id='myForm' onSubmit={sendEmail}>
                <div className='form-group'>
                  <input
                    type='email'
                    name='email'
                    placeholder='Enter Your Email'
                    className='form-control'
                    id='email'
                  />
                </div>
                <div className='form-group'>
                  <input
                    type='text'
                    name='name'
                    placeholder='Enter Your Name'
                    className='form-control'
                    id='name'
                  />
                </div>
                <div className='form-group'>
                  <input
                    type='text'
                    name='subject'
                    placeholder='Enter Your Subject'
                    className='form-control'
                    id='subject'
                  />
                </div>
                <div className='form-group'>
                  <textarea
                    className='form-control'
                    name='message'
                    placeholder='Your Message'
                    id='textarea'
                    cols='5'
                    rows='2'
                  ></textarea>
                </div>
                <button type='submit' className='btn btn-danger'>
                  Submit
                </button>
              </form>
            </div>
            <div className='col-md-6'>
              <div className='text-center mb-3'>
                <h5 style={{ color: "#138496" }}>Reach out to me directly</h5>
              </div>
              <div className='contact-direct'>
                <div className='row'>
                  <div className='col-sm-6'>
                    <div className='item d-flex'>
                      <span className='text-white mr-2'>
                        <FaEnvelope />
                      </span>
                      <p className='text-white'>Sirajgonj, Dhaka, Bangladesh</p>
                    </div>
                  </div>

                  <div className='col-sm-6'>
                    <div className='item d-flex'>
                      <span className='text-white mr-2'>
                        <FaPhoneAlt />
                      </span>
                      <p className='text-white'>+8801681876442</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='contact-map'>
                <iframe
                  src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d465085.7338051916!2d89.25575532553795!3d24.39930677888745!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39fdcf228688008d%3A0x16f56a2c551fbd48!2sSirajganj%20District!5e0!3m2!1sen!2sbd!4v1604089230494!5m2!1sen!2sbd'
                  frameBorder='0'
                  allowFullScreen=''
                  aria-hidden='false'
                  title='Contact Me'
                  tabIndex='0'
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
